module.exports = __webpack_public_path__ + "img/icon-hearth-active.3580ad0a.png";